import useDevice from "hooks/useDevice";
import { observer } from "mobx-react";
import { MobileFilterPanel } from "./MobileFilterPanel";
import { useState } from "react";
import { FilterForm } from "./FilterForm";
import { MobileFilterButton } from "./MobileFilterButton";
import { useMapStore, useUserRolePermissionStore } from "contexts/RootStore.context";


export const Filter = observer(() => {

  const { isTabletDevice } = useDevice();
  const { canViewAssets } = useUserRolePermissionStore();
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  const { loading } = useMapStore()

  function handleMobileFilterClick() {
    setMobileFilterOpen(!mobileFilterOpen);
  }

  return (
    <>
      {isTabletDevice && canViewAssets &&
        <MobileFilterPanel
          isOpen={mobileFilterOpen}
          onClose={() => setMobileFilterOpen(false)}
        />
      }
      {!isTabletDevice && <FilterForm />}
      {isTabletDevice && canViewAssets && !loading && (
        <MobileFilterButton onClick={handleMobileFilterClick} />
      )}
    </>
  )
})